import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export default function UploadWhatHappensNext({
  className,
}: {
  /** Extra classes for the card wrapper, for page-level vertical spacing. */
  className?: string;
}) {
  const { t } = useTranslation(["upload"]);

  return (
    <div
      className={cn(
        "rounded-[var(--r-lg)] border border-[var(--border)] bg-[color:color-mix(in_srgb,var(--accent)_55%,var(--card))] p-6",
        className,
      )}
    >
      <h3 className="mb-3 flex items-center text-sm font-semibold text-[var(--foreground)]">
        <Info className="mr-2 h-5 w-5 text-[var(--primary)]" aria-hidden="true" />
        {t("upload:whatHappensNext.title")}
      </h3>
      <ol className="space-y-3 text-sm text-[var(--foreground)]">
        <li className="flex items-start">
          <span className="mr-3 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[var(--primary)] text-xs font-semibold text-[var(--primary-foreground)]">
            1
          </span>
          <span>{t("upload:whatHappensNext.step1")}</span>
        </li>
        <li className="flex items-start">
          <span className="mr-3 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[var(--primary)] text-xs font-semibold text-[var(--primary-foreground)]">
            2
          </span>
          <span>{t("upload:whatHappensNext.step2")}</span>
        </li>
        <li className="flex items-start">
          <span className="mr-3 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-[var(--primary)] text-xs font-semibold text-[var(--primary-foreground)]">
            3
          </span>
          <span>{t("upload:whatHappensNext.step3")}</span>
        </li>
      </ol>
    </div>
  );
}
